import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'types';
import { initialState } from './index';

const selectSlice = (state: RootState) => state.savedViews || initialState;

export const selectSavedViews = createSelector(
  selectSlice,
  state => state.savedViews
);

export const selectSavedViewsLoading = createSelector(
  selectSlice,
  state => state.loading
);

export const selectSavedViewsSaving = createSelector(
  selectSlice,
  state => state.saving
);

export const selectSavedViewsDeleting = createSelector(
  selectSlice,
  state => state.pendingDeleteCount > 0
);

export const selectSavedViewsError = createSelector(
  selectSlice,
  state => state.error
);
